import { render, staticRenderFns } from "./AdminsPanel.vue?vue&type=template&id=2774bea2&scoped=true"
import script from "./AdminsPanel.vue?vue&type=script&lang=js"
export * from "./AdminsPanel.vue?vue&type=script&lang=js"
import style0 from "./AdminsPanel.vue?vue&type=style&index=0&id=2774bea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2774bea2",
  null
  
)

export default component.exports